(function($){

	$(document).ready(function(){

		$(document).on('click','.addtocart__trigger',function(e){
			e.preventDefault();
			$postid = parseInt($(this).data('postid'));

			var usercart_array = new Array();

			if(Cookies.get('usercartcookie')) {
				var usercart_string = Cookies.get('usercartcookie');
				usercart_array = JSON.parse(usercart_string);
			}
			
			if(!usercart_array.includes($postid)) {
				usercart_array.push($postid);	
				Cookies.set('usercartcookie',JSON.stringify(usercart_array));
				show_message('Item added to cart!', 'success');
				update_cart_count();
			} else {
				show_message('Item already in cart!', 'error');
				return;	
			}
		});


		$(document).on('click','.addtocart-bulk__trigger',function(e){
			
			e.preventDefault();

			if(!$(this).hasClass('disabled')) {
				
				$(this).addClass('disabled');

				$selected_items = $(this).parents('.gazoo-grid__container').find('.gazoo-grid').find('.gazoo-grid__item.selected');

				if($selected_items.length == 0) {
					show_message('Please select some items!', 'error');
					$(this).removeClass('disabled');
					return;
				}

				var usercart_array = new Array();

				if(Cookies.get('usercartcookie')) {
					var usercart_string = Cookies.get('usercartcookie');
					usercart_array = JSON.parse(usercart_string);
				}

				$items_found = 0;

				$.each($selected_items,function(index){

					var $postid = $(this).find('.addtocart__trigger').data('postid');
					
					if(!usercart_array.includes($postid)) {
						usercart_array.push($postid);	
						$items_found = 1;
					}	

				});

				Cookies.set('usercartcookie',JSON.stringify(usercart_array));
				
				if($items_found == 1) {
					show_message('Item(s) successfully added to cart!', 'success');
					update_cart_count();
				} else {
					show_message('Item(s) already in cart!', 'error');
				}
			}
		});

		$(document).on('click','.cart-contents__block-items li', function(e){
			e.preventDefault();
			$(this).toggleClass('selected');
		});

		$(document).on('click','.menu.cart-actions .btn-select-all', function(e){
			e.preventDefault();
			$(this).parents('.menu.cart-actions').siblings('.cart-contents__wrapper').find('.cart-item').addClass('selected');
		});

		$(document).on('click','.menu.cart-actions .btn-deselect-all', function(e){
			e.preventDefault();
			$(this).parents('.menu.cart-actions').siblings('.cart-contents__wrapper').find('.cart-item').removeClass('selected');
		});

		$(document).on('click','.menu.cart-actions .btn-delete',function(e){
			e.preventDefault();

			var $target_element = $(this).parents('.menu.cart-actions').siblings('.cart-contents__wrapper').find('.cart-item.selected');

			if($target_element.length == 0) {
				show_message('Please select some items to delete!','error');
				return;
			}

			var usercart_array = new Array();

			if(Cookies.get('usercartcookie')) {
				var usercart_string = Cookies.get('usercartcookie');
				usercart_array = JSON.parse(usercart_string);
			}

			$.each($target_element, function(index){
				var $post_id = $(this).data('postid');	
				var result = arrayRemove(usercart_array, $post_id);
				usercart_array = result;
				$('li[data-postid="' + $post_id + '"]').remove();
			});

			Cookies.set('usercartcookie',JSON.stringify(usercart_array));

			if($('.cart-item').length == 0) {
				$('.cart-actions').remove();
				$('.cart-contents__wrapper').html('<h4 class="cart-error">Cart is Empty!</h4>');
			}

			update_cart_count();

		});

		
		$(document).on('click','.btn-email-cart',function(e){
			e.preventDefault();
			$btn = $(this);
			
			var cartEmail = $('.cart-email__section input[type="email"]').val();

			if (!validateEmail(cartEmail)) {
				show_message('Please enter a valid email address!','error');
				$('.cart-email__section input[type="email"]').focus();
	    	} else {
	    		
	    		if(Cookies.get('usercartcookie') && Cookies.get('usercartcookie') != '[]') {
	    			$btn.addClass('processing');

					var usercart_string = Cookies.get('usercartcookie');

					$.ajax({
			        	url : user_vars.ajax_url,
			        	type : 'POST',
			        	data : {
			          		action : 'email_cart',
			          		to_email : cartEmail,
			          		cartcontents : usercart_string
			        	},
			        	success : function(response) {
			        		show_message(response.msg, 'success');
							Cookies.set('usercartcookie', '[]');
			        		$btn.removeClass('processing');
			        		$('.cart-actions').remove();
							$('.cart-contents__wrapper').html('<h4 class="cart-error">Cart is Empty!</h4>');
			        	},
			        	error: function(response) {
			          		show_message('There was an error sending out email, please try later!','error');
			          		$btn.removeClass('processing');
			        	}
			    	});

				} else {
					show_message('Nothing to email, Cart is Empty!','error');
				}
	    	}	
		});
	
	});

	function show_message(msg, type) {
		let messageDiv = document.createElement('div');
		messageDiv.textContent = msg;
		messageDiv.classList.add('gazoo-message');
		messageDiv.classList.add(type);
		document.body.appendChild(messageDiv);

		setTimeout(function(){
			messageDiv.classList.add('active');
		}, 200);

		setTimeout(function(){
			messageDiv.classList.remove('active');
		}, 1500);

		setTimeout(function(){
			messageDiv.remove();
		}, 2500);
	}

	function arrayRemove(arr, value) {
		return arr.filter(function(ele){
			return ele != value;
		});
	}

	function update_cart_count() {
		var cart_count = 0;

		if(Cookies.get('usercartcookie')) {
			var usercart_string = Cookies.get('usercartcookie');
			usercart_array = JSON.parse(usercart_string);

			cart_count = usercart_array.length;
		}

		if(cart_count > 0) {
			$('.cart-count').html(cart_count).removeClass('hide');
		} else {
			$('.cart-count').html(cart_count).addClass('hide');
		}
	}

	function validateEmail(email) {
	    var filter = /^([\w-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
	    return filter.test(email);
  	}
	
})(jQuery);